export default {
    data: () => ({
        translations: {
            title: {
                el: "Καλάθι Αγορών",
                en: "Shopping Cart",
                it: "Carrello della spesa"
            },
            info: {
                el: "Η ενεργοποίηση του 'Καλαθιού αγορών' θα επιτρέψει στους πελάτες σας να παραγγείλουν περισσότερα από ένα προϊόντα στο κατάστημά σας μέσω της εφαρμογής για κινητά.  Λάβετε υπόψη ότι για να ενεργοποιηθεί το 'Καλάθι αγορών', πρέπει πρώτα να ενεργοποιήσετε τις 'Παραγγελίες' μέσω της καρτέλας 'Ανταμοιβή'.",
                en: `
                    Activating “Shopping Cart” will allow customers to order more than one
                    product into your store via mobile application. Keep in mind that for
                    “Shopping Cart” to be activated, you first need to activate the “Orders”
                    through the “Reward” tab.
                `,
                it: "Attivando 'Carrello' i clienti potranno ordinare più di un prodotto nel tuo negozio tramite l'applicazione mobile. Tieni presente che per attivare il 'Carrello', devi prima attivare gli 'Ordini' attraverso la scheda 'Ricompensa'."
            },
            toggle: {
                el: "Ενεργοποίηση Καλάθι Αγορών",
                en: "Activate Shopping Cart",
                it: "Attivare il carrello"
            },
            on: {
                el: "Ενεργό",
                en: "On",
                it: "Sopra"
            },
            off: {
                el: "Ανενεργό",
                en: "Off",
                it: "Off"
            }
        }
    })
};
